module.exports = __webpack_public_path__ + "images/42f24042.img_usa_win_3.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/img_usa_win_3.jpg
// module id = 339
// module chunks = 0